import React, { CSSProperties, ReactNode } from 'react'

import { Avatar } from 'antd'

interface AvatarProps {
  size?: 'large' | 'default' | 'small' | number
  shape?: 'square' | 'circle'
  icon?: string | ReactNode
  text?: string
  src?: string
  style?: CSSProperties
  className?: string
}

const Display = ({ children, ...props }: React.PropsWithChildren<AvatarProps>) => {
  return (
    <Avatar {...props} icon={props.text ? null : props.icon}>
      <span>{props.text}</span>
      {children}
    </Avatar>
  )
}

export default Display
